<% var component = new Anvil.models.components.ChartHost(params) %>
<canvas anvil-component="<%- component.id %>"></canvas>